import { render, staticRenderFns } from "./StatementFileSettting.vue?vue&type=template&id=4a396927"
import script from "./StatementFileSettting.vue?vue&type=script&lang=js"
export * from "./StatementFileSettting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports